import React, { VFC } from 'react';
import { useTranslation } from 'react-i18next';
import SearchIcon from '@material-ui/icons/Search';

import Styled from '../Styled';
import IconWithWord from '../molecules/MuiIconWithWord';
import { useTheme } from '@material-ui/core/styles';
import { HEADER_SEARCH_DRAWER_BUTTON } from '../../../constants/gtm';

const { IconWrapper, IconLink } = Styled;

interface Props {
  onClick: () => void;
}
const SearchIconLink: VFC<Props> = ({ onClick }: Props) => {
  const { t } = useTranslation();
  const theme = useTheme();
  return (
    <IconWrapper theme={theme}>
      <IconLink data-gtm={HEADER_SEARCH_DRAWER_BUTTON}>
        <IconWithWord
          Icon={SearchIcon}
          word={t('header.menu.search')}
          onClick={onClick}
        />
      </IconLink>
    </IconWrapper>
  );
};

export default SearchIconLink;
